<script setup>
import { onBeforeUnmount, onBeforeMount, ref } from "vue";

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "@/firebase";
import ArgonAlert from "../components/ArgonAlert.vue";

const body = document.getElementsByTagName("body")[0];

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});
const loading = ref(false);

const alertMessage = ref('');
const alertColor = ref('danger');
const showAlert = ref(false);
const email = ref("");
const password = ref("");
const errors = ref({
  email: "",
  password: ""
});

const router = useRouter();

const validateUser = () => {
  const newErrors = {};

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email.value.trim()) {
    newErrors.email = "Bắt buộc phải có email!";
  } else if (!emailRegex.test(email.value)) {
    newErrors.email = "Định dạng email không hợp lệ!";
  }

  if (!password.value.trim()) {
    newErrors.password = "Cần phải nhập mật khẩu!";
  }

  errors.value = newErrors;
  return Object.keys(newErrors).length === 0;
};


const login = async () => {
  if (!validateUser()) return;
  loading.value = true;
  showAlert.value = false;

  try {
    const userCredential = await signInWithEmailAndPassword(auth, email.value, password.value);
    const user = userCredential.user;

    if (!user.emailVerified) {
      alertMessage.value = 'Email của bạn chưa được xác thực. Vui lòng kiểm tra hộp thư để xác minh tài khoản.';
      alertColor.value = 'danger';
      showAlert.value = true;
      loading.value = false;
      return;
    }

    const token = await userCredential.user.getIdToken();
    localStorage.setItem("accessToken", token);
    localStorage.setItem("userEmail", userCredential.user.email);
    await router.push({ path: "/" });

  } catch (err) {
    loading.value = false;
    showAlert.value = true;

    if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
      alertMessage.value = 'Email hoặc mật khẩu không đúng.';
    } else {
      alertMessage.value = 'Đăng nhập thất bại. Vui lòng thử lại.';
    }

    alertColor.value = 'danger';
  }
};

</script>

<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div v-if="showAlert" class="mb-4">
                  <ArgonAlert :color="alertColor" dismissible>
                    {{ alertMessage }}
                  </ArgonAlert>
                </div>
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Đăng nhập</h4>
                  <p class="mb-0">Nhập email và mật khẩu của bạn để đăng nhập</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="login">
                    <div class="mb-3">
                      <argon-input
                        v-model="email"
                        id="email"
                        type="email"
                        placeholder="Email"
                        name="email"
                        size="lg"
                      />
                      <p class="text-danger text-sm" v-if="errors.email">{{ errors.email }}</p>
                    </div>

                    <div class="mb-3">
                      <argon-input
                        v-model="password"
                        id="password"
                        type="password"
                        placeholder="Password"
                        name="password"
                        size="lg"
                      />
                      <p class="text-danger text-sm" v-if="errors.password">{{ errors.password }}</p>
                    </div>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="dark"
                        fullWidth
                        size="lg"
                      >
                        Đăng nhập
                      </argon-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Bạn chưa có tài khoản?
                    <RouterLink to="/signup" class="text-warning text-gradient font-weight-bold">Đăng ký</RouterLink>
                  </p>
                </div>
              </div>
            </div>

            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-warning h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background-image: url('https://i.chungta.vn/2024/01/09/-8679-1704790860_1200x0.jpg'); background-size: cover;"
              >
                <span class="mask bg-gradient-faded-secondary opacity-6"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">
                  "BÁO CHÍ NÓI VỀ FPT POLYSCHOOL"
                </h4>
                <p class="text-white position-relative">
                  FPT PolySchool: Hành trình chinh phục thế giới từ tư duy giáo dục khác biệt                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
